import { useEffect, useState } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { Branch } from "../types/branch";
import { formatDateForInput } from "../utils/date";

export const useBranchData = (id: string, updateFormData: (data: Partial<any>) => void) => {
  const [branchData, setBranchData] = useState<Branch>();

  useEffect(() => {
    api.get(`/app/pos/v2/branch/${id}`).then((res) => {
      const branch: Branch = res.data.result;
      setBranchData(branch);

      updateFormData({
        name: branch.name,
        openingDate: branch.openingDate,
        inputValue: formatDateForInput(branch.openingDate),
        addressLine1: branch.addresses.addressLine1,
        addressLine2: branch.addresses.addressLine2,
        postalCode: branch.addresses.postalCode,
        country: branch.addresses.country,
        state: branch.addresses.state,
        city: branch.addresses.city,
      });
    });
  }, [id]);

  return branchData;
};
